module.exports = __webpack_public_path__ + "img/step07_b_insert_bottom_cross_into_right_bottom_connector_Julio2023.5e3657c3.png";